import type { RemoteErrorMetadata } from './types';

export const REMOTE_OBSERVABILITY_EVENT = 'm360:remote-observability';

export type RemoteObservabilityStage =
  | 'remote_load_start'
  | 'remote_load_success'
  | 'remote_load_failure'
  | 'remote_render_failure';

export interface RemoteObservabilityEvent {
  stage: RemoteObservabilityStage;
  remoteName: RemoteErrorMetadata['remoteName'];
  routePath: string;
  moduleId: string;
  correlationId: string;
  durationMs?: number;
  errorMessage?: string;
}

function emitEvent(payload: RemoteObservabilityEvent) {
  window.dispatchEvent(
    new CustomEvent(REMOTE_OBSERVABILITY_EVENT, {
      detail: payload,
    })
  );
}

function emitConsole(payload: RemoteObservabilityEvent) {
  if (payload.stage !== 'remote_load_failure' && payload.stage !== 'remote_render_failure') {
    return;
  }

  const context = {
    remoteName: payload.remoteName,
    routePath: payload.routePath,
    moduleId: payload.moduleId,
    correlationId: payload.correlationId,
    durationMs: payload.durationMs,
  };

  console.error('[RemoteRoute]', payload.stage, {
    ...context,
    errorMessage: payload.errorMessage,
  });
}

export function publishRemoteObservabilityEvent(payload: RemoteObservabilityEvent) {
  emitEvent(payload);
  emitConsole(payload);
}
